import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import LineItem from './LineItem'
import animations from '../../animations.module.scss'
import { CartLineItem as LineItemType } from 'types/checkout'
import { GenericFunction } from 'types/helpers'
import { Layout } from './CartItem'
import { removeSubdomainInUrl } from '@helpers/utils'

type CartProductsListProps = {
  updateCartQuantity: GenericFunction
  lineItems: LineItemType[]
  layout: Layout
}

function CartProductsList({
  updateCartQuantity,
  lineItems = [],
  children = null,
  layout = 'small'
}: React.PropsWithChildren<CartProductsListProps>) {
  return (
    <TransitionGroup className={animations.basket__items}>
      {lineItems.map(item => (
        <CSSTransition
          key={item.id}
          timeout={300}
          classNames="transition__item"
        >
          <LineItem
            itemId={item.id}
            inventoryQuantity={item.merchandise.quantityAvailable}
            image={item.merchandise.image ? item.merchandise.image.url : ''}
            productTitle={item.merchandise.product.title}
            productType={item.merchandise.product.productType}
            price={item.merchandise.price}
            compareAtPrice={item.merchandise.compareAtPrice}
            quantity={item.quantity}
            properties={item.attributes}
            discounts={item.discountAllocations}
            updateQuantity={(id, qty) =>
              updateCartQuantity(id, item.merchandise.id, qty)
            }
            url={removeSubdomainInUrl(item.merchandise.product.url)}
            layout={layout}
          />
        </CSSTransition>
      ))}
      {children}
    </TransitionGroup>
  )
}

export default CartProductsList
